export function formatPreparationTime(time: string): string {
    // Expected format: "HH:MM:SS"
    const [hours, minutes] = time.split(':').map(Number);

    if (hours > 0) {
        return `${hours}h ${minutes}m`;
    }

    return `${minutes} min`;
}
